import { DialogProps, Dialog as AriaDialog } from 'react-aria-components';
import { twMerge } from 'tailwind-merge';

const Dialog = ({ className, role = 'dialog', ...props }: DialogProps) => {
  return (
    <AriaDialog
      role={role}
      {...props}
      className={twMerge(
        'outline outline-0 max-h-[inherit] p-6 overflow-auto relative w-full rounded-2xl bg-surface-alt',
        className
      )}
    />
  );
};

export default Dialog;
